import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const ArrowLeftLineIcon: FC<IconType> = (props) => {
  const { width, height, color, strokeWidth, style, className } = {
    ...DEFAULT_ICON_PROPS,
    width: 24,
    height: 24,
    strokeWidth: 2,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      className={className}
      aria-hidden={props['aria-hidden']}
      aria-label={props['aria-label']}
    >
      <path d="m12 19-7-7 7-7" />
      <path d="M19 12H5" />
    </svg>
  );
};
